import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_2 = { height: "100" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = { height: "80%" }
const _hoisted_5 = { class: "quotewizard" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { height: "80" }
const _hoisted_8 = {
  class: "quote-footer",
  style: {"text-align":"center"}
}

import LoggedInBar from "@/views/partials/LoggedInBar.vue";
import MyLogo from "@/views/partials/RentersLogo.vue";
import { removeNoScroll } from "@/utils/NoScroll";
import { onMounted } from "vue";
import { getCurrentYear } from "@/utils/Utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'LegalAssurant',
  setup(__props) {

onMounted(() => {
  removeNoScroll();
  window.scrollTo(0, 0);
});

return (_ctx: any,_cache: any) => {
  const _component_center = _resolveComponent("center")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(LoggedInBar),
    _cache[27] || (_cache[27] = _createElementVNode("h1", null, "Renters Insurance by National Student Services, Inc. (NSSI)", -1)),
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(MyLogo)
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_4, [
            _createElementVNode("section", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                _cache[3] || (_cache[3] = _createElementVNode("div", {
                  class: "title",
                  style: {"text-align":"center"}
                }, " Assurant Legal ", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("a", {
                      href: "#",
                      onclick: "window.history.back();"
                    }, "❮  Back", -1)
                  ]))]),
                  _: 1
                }),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "subtitle" }, "Underwriters", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                _cache[9] || (_cache[9] = _createElementVNode("p", null, " In all states, unless otherwise noted, Renters Insurance is underwritten by American Bankers Insurance Company of Florida with its home office in Miami, Florida. In Minnesota, the underwriter is American Security Insurance company. In Georgia, Residents Liability is underwritten by Voyager Indemnity Insurance Company. These companies operate under the trade name Assurant. ", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("p", null, " In Utah, coverage is provided under policy form AJ8850PC-0307 or AJ9281CKK-0609. ", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "subtitle" }, "Underwriting Entities", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                _cache[15] || (_cache[15] = _createElementVNode("p", null, " You are provided the following information pursuant to various state insurance laws, including, but not limited to, those of California, Massachusetts and Missouri. Each insurer has sole financial responsibility for its own products. ", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "scrolltable" }, [
                  _createElementVNode("table", {
                    class: "styledtable",
                    cellspacing: "0",
                    cellpadding: "0"
                  }, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Insurance Company")
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "National Association of Insurance Commissioners' ID #")
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Jurisdictions in US Where Authorized to Do Business")
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "State of Domicile ")
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "American Bankers Insurance Company of Florida"),
                          _createElementVNode("br"),
                          _createTextVNode("11222 Quail Roost Drive"),
                          _createElementVNode("br"),
                          _createTextVNode("Miami, FL 33157"),
                          _createElementVNode("br"),
                          _createElementVNode("span", null, "(305) 253-2244")
                        ]),
                        _createElementVNode("td", null, " 10111"),
                        _createElementVNode("td", null, " All States & the District of Columbia"),
                        _createElementVNode("td", null, " Florida")
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "American Security Insurance Company"),
                          _createElementVNode("br"),
                          _createTextVNode("260 Interstate N Circle - SE"),
                          _createElementVNode("br"),
                          _createTextVNode("Atlanta, GA 30339 "),
                          _createElementVNode("br"),
                          _createElementVNode("span", null, "(770) 763-1000")
                        ]),
                        _createElementVNode("td", null, " 42978"),
                        _createElementVNode("td", null, " All States except NH"),
                        _createElementVNode("td", null, " Delaware")
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Voyager Indemnity Insurance Company"),
                          _createElementVNode("br"),
                          _createTextVNode("260 Interstate N Circle - SE"),
                          _createElementVNode("br"),
                          _createTextVNode("Atlanta, GA 30339 "),
                          _createElementVNode("br"),
                          _createElementVNode("span", null, "(770) 763-1000")
                        ]),
                        _createElementVNode("td", null, " 40428"),
                        _createElementVNode("td", null, " Georgia"),
                        _createElementVNode("td", null, " Georgia")
                      ])
                    ])
                  ])
                ], -1)),
                _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(" © " + _toDisplayString(_unref(getCurrentYear)) + " National Student Services, Inc. All Rights Rights Reserved.", 1),
              _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
              _cache[23] || (_cache[23] = _createElementVNode("a", {
                href: "https://nssi.com/terms-of-use",
                target: "_blank"
              }, "Terms of Use", -1)),
              _cache[24] || (_cache[24] = _createTextVNode("  |  ", -1)),
              _cache[25] || (_cache[25] = _createElementVNode("a", {
                href: "https://nssi.com/privacy-policy",
                target: "_blank"
              }, "Privacy Policy", -1)),
              _cache[26] || (_cache[26] = _createTextVNode("  |  ", -1)),
              _createVNode(_component_router_link, { to: { name: 'legalAssurant' } }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode("Assurant Legal", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})